import { render } from "./AccountingPaymentImportsTable.vue?vue&type=template&id=7a545edb&scoped=true&ts=true&lang=pug"
import script from "./AccountingPaymentImportsTable.vue?vue&type=script&lang=ts"
export * from "./AccountingPaymentImportsTable.vue?vue&type=script&lang=ts"

import "./AccountingPaymentImportsTable.vue?vue&type=style&index=0&id=7a545edb&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a545edb"]])

export default __exports__